<template>
	<div>
		<div class="text-label-secondary text-xs font-medium uppercase">
			{{ title }}
		</div>
		<div
			class="border-separator-secondary shadow-input mt-1.5 flex h-10 w-full min-w-0 items-center rounded-[10px] border bg-black px-3"
			@click="focusInput"
		>
			<CoinIcon class="h-5 w-5 shrink-0" />
			<BaseInput
				id="price"
				v-model="price"
				type="number"
				class="w-full min-w-0 py-2 pr-1.5 pl-1.5 disabled:opacity-60"
				:placeholder="placeholder"
				ref="input"
				@focusout="focusOut"
				@enter="enter"
				@submit="enter"
			/>
			<CloseIcon
				class="h-5 w-5 after:absolute after:-inset-3"
				v-hover="{ active: 'scale-90', impact: 'soft' }"
				@click="reset()"
			/>
		</div>
	</div>
</template>
<script setup lang="ts">
import BaseCard from './BaseCard.vue'
import BaseInput from './BaseInput.vue'
import { nextTick, ref } from 'vue'
import CoinIcon from '@/assets/icons/coin.svg'
import CloseIcon from '@/assets/icons/close.svg'

defineProps<{
	placeholder?: string
	title: string
}>()

const price = defineModel<number>()

const emit = defineEmits<{
	(e: 'enter'): void
	(e: 'focusout'): void
}>()

const focus = ref(false)
const input = ref()

const focusInput = async () => {
	if (focus.value) {
		return
	}

	focus.value = true

	await nextTick()

	if (!input.value) {
		focus.value = true
		return
	}

	input.value.focus()

	if (price.value !== undefined) {
		input.value.select()
	}
}

const focusOut = () => {
	focus.value = false

	emit('focusout')
}

const enter = () => {
	if (price.value === undefined) {
		return
	}

	focus.value = false

	emit('enter')
}

const reset = () => {
	price.value = undefined
	focusOut()
}

defineExpose({
	focusInput,
	focusOut
})
</script>
